import compositeNames from './displayNames';
import originalCompositeNames from '../composites/displayNames';
import { childType } from '../composites/childValidation';
import controlNames from '../controls/displayNames';
export default {
  OneInputInRow: {
    displayName: compositeNames.ONE_INPUT_IN_ROW,
    className: 'composite-one-input-in-row',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_WITH_DROP_DOWN_LABELED_HORIZONTAL, compositeNames.INPUT_LABELED)]
  },
  InputWithSymbolBelow: {
    displayName: compositeNames.INPUT_WITH_SYMBOL_BELOW,
    className: 'composite-input-with-symbol-below',
    childrenTypes: [childType.once(controlNames.DROP_DOWN, controlNames.NUMERIC_INPUT, controlNames.TEXT_INPUT), childType.once(controlNames.Symbol)]
  },
  TwoInputsInRow: {
    displayName: compositeNames.TWO_INPUTS_IN_ROW,
    className: 'composite-two-inputs-in-row',
    childrenTypes: [childType.once(controlNames.TEXT_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_LABELED), childType.optional(controlNames.TEXT_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_LABELED)]
  },
  TwoInputsWithLabel: {
    displayName: compositeNames.TWO_INPUTS_WITH_LABEL,
    className: 'composite-two-inputs-with-label',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_LABELED), childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_LABELED)]
  },
  InputWithLabelAndSymbol: {
    displayName: compositeNames.INPUT_WITH_LABEL_AND_SYMBOL,
    className: 'composite-input-with-label-and-symbol',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT, compositeNames.INPUT_WITH_DROP_DOWN, compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_LABELED), childType.once(controlNames.Symbol)]
  },
  InputLabeled: {
    displayName: compositeNames.INPUT_LABELED,
    className: 'composite-input-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.TEXT_INPUT)]
  },
  NumericInputLabeled: {
    displayName: compositeNames.NUMERIC_INPUT_LABELED,
    className: 'composite-numeric-input-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL, controlNames.DROP_DOWN), childType.once(controlNames.TEXT_INPUT, controlNames.NUMERIC_INPUT)]
  },
  InputWithDropDownLabeled: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN_LABELED,
    className: 'composite-input-with-drop-down-labeled',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.INPUT_WITH_DROP_DOWN)]
  },
  InputWithDropDownLabeledHorizontal: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN_LABELED_HORIZONTAL,
    className: 'composite-input-with-drop-down-labeled-horizontal',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.INPUT_WITH_DROP_DOWN)]
  },
  InputWithDropDownLabeledTop: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN_LABELED_TOP,
    className: 'composite-input-with-drop-down-labeled-top',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.INPUT_WITH_DROP_DOWN)]
  },
  InputWithDropDownSymbol: {
    displayName: compositeNames.INPUT_WITH_DROP_DOWN_SYMBOL,
    className: 'composite-input-with-drop-down-symbol',
    childrenTypes: [childType.once(compositeNames.INPUT_WITH_DROP_DOWN), childType.once(controlNames.Symbol)]
  },
  MultiInputsInRow: {
    displayName: compositeNames.MULTI_INPUTS_IN_ROW,
    className: 'composite-multi-inputs-in-row',
    childrenTypes: [childType.multiple(compositeNames.TWO_INPUTS_IN_ROW)]
  },
  MultiInputWithDropDown: {
    displayName: compositeNames.MULTI_INPUT_WITH_DROP_DOWN,
    className: 'composite-multi-input-with-drop-down',
    childrenTypes: [childType.multiple(compositeNames.INPUT_WITH_DROP_DOWN)]
  },
  MultiInputWithDropDownLabeled: {
    displayName: compositeNames.MULTI_INPUT_WITH_DROP_DOWN_LABELED,
    className: 'composite-multi-input-with-drop-down-labeled',
    childrenTypes: [childType.optional(controlNames.TEXT), childType.optional(controlNames.ICON_BUTTON), childType.optional(controlNames.INFO_ICON), childType.multiple(compositeNames.INPUT_WITH_DROP_DOWN_LABELED, compositeNames.INPUT_WITH_DROP_DOWN_LABELED_HORIZONTAL, compositeNames.INPUT_WITH_DROP_DOWN_SYMBOL)]
  },
  DockingControl: {
    displayName: compositeNames.DOCKING_CONTROL,
    className: 'composite-docking-control',
    childrenTypes: [childType.optional(controlNames.DOCKING_PANEL, compositeNames.DOCKING_CONTROL_WITH_LABEL), childType.optional(compositeNames.MULTI_INPUT_WITH_DROP_DOWN, compositeNames.MULTI_INPUT_WITH_DROP_DOWN_LABELED)]
  },
  DockingControlWithLabel: {
    displayName: compositeNames.DOCKING_CONTROL_WITH_LABEL,
    className: 'composite-docking-control-with-label',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DOCKING_PANEL)]
  },
  IconTabs: {
    displayName: compositeNames.ICON_TABS,
    className: 'composite-icon-tabs',
    childrenTypes: [childType.once(controlNames.THUMBNAILS), childType.optional(controlNames.TEXT_LABEL)]
  },
  CollapseLabelWithInfoIcon: {
    displayName: compositeNames.COLLAPSE_LABEL_WITH_INFO_ICON,
    className: 'composite-collapse-label-with-info-icon',
    childrenTypes: [childType.once(controlNames.COLLAPSE_LABEL), childType.optional(controlNames.INFO_ICON)]
  },
  CheckboxesLabeled: {
    displayName: compositeNames.CHECKBOXES_LABELED,
    className: 'composite-checkboxes-labeled composite-with-info-icon',
    childrenTypes: [childType.optional(controlNames.INFO_ICON), childType.once(controlNames.TEXT_LABEL), childType.multiple(compositeNames.CHECKBOX_WITH_INFO_ICON, controlNames.CHECKBOX, compositeNames.CHECKBOX_INDENTED)]
  },
  TextLabelWithIcon: {
    displayName: compositeNames.TEXT_LABEL_WITH_ICON,
    className: 'composite-text-label-with-icon',
    childrenTypes: [childType.optional(controlNames.Symbol), childType.optional(controlNames.ICON_BUTTON), childType.once(controlNames.TEXT_LABEL)]
  },
  TwoTextLabelsInRow: {
    displayName: compositeNames.TWO_TEXT_LABELS_IN_ROW,
    className: 'composite-two-text-labels-in-row',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.optional(controlNames.TEXT_LABEL, compositeNames.TEXT_LABEL_WITH_ICON)]
  },
  DefaultPanelPadding: {
    displayName: compositeNames.DEFAULT_PANEL_PADDING,
    className: 'composite-default-panel-padding',
    childrenTypes: [childType.optional(controlNames.CHECKBOX), childType.optional(controlNames.TEXT_LABEL), childType.optional(controlNames.TEXT_INPUT), childType.optional(controlNames.BUTTON), childType.optional(controlNames.RICH_TEXT)]
  },
  DropDownLabeledHorizontal: {
    displayName: compositeNames.DROP_DOWN_LABELED_HORIZONTAL,
    className: 'composite-drop-down-labeled-horizontal',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(compositeNames.DROP_DOWN_LABELED_HORIZONTAL)]
  },
  DropDownLabeledVertical: {
    displayName: compositeNames.DROP_DOWN_LABELED_VERTICAL,
    className: 'composite-drop-down-labeled-vertical',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.DROP_DOWN)]
  },
  MultiRowsOfTwoInputsInRow: {
    displayName: compositeNames.MULTI_ROWS_OF_TWO_INPUTS_IN_ROW,
    className: 'composite-multi-rows-of-two-inputs-in-row',
    childrenTypes: [childType.multiple(compositeNames.TWO_INPUTS_IN_ROW)]
  },
  ThumbnailsLabeledHorizontal: {
    displayName: compositeNames.THUMBNAILS_LABELED_HORIZONTAL,
    className: 'composite-thumbnails-labeled-horizontal',
    childrenTypes: [childType.once(controlNames.TEXT_LABEL), childType.once(controlNames.THUMBNAILS)]
  },
  PanelFooterButtonWithIcon: {
    displayName: compositeNames.PANEL_FOOTER_BUTTON_WITH_ICON,
    className: 'composite-panel-footer-button-with-icon',
    childrenTypes: [childType.once(controlNames.BUTTON), childType.once(controlNames.THUMBNAILS)]
  },
  EmptyState: {
    displayName: compositeNames.EMPTY_STATE,
    className: 'composite-empty-state',
    childrenTypes: [childType.optional(controlNames.Symbol), childType.optional(controlNames.Spacer), childType.optional(controlNames.TEXT_LABEL), childType.optional(controlNames.Spacer), childType.optional(controlNames.TEXT_LABEL), childType.optional(controlNames.TEXT_BUTTON), childType.optional(controlNames.Spacer), childType.optional(controlNames.BUTTON)]
  },
  PopupConfirmation: {
    displayName: compositeNames.POPUP_CONFIRMATION,
    className: 'composite-popup composite-popup-small-size responsive-popup-confirmation',
    childrenTypes: [childType.once(controlNames.PANEL_HEADER), childType.once(originalCompositeNames.PANEL_CONTENT), childType.optional(originalCompositeNames.ACTION_SET_HORIZONTAL, originalCompositeNames.ACTION_SET_HORIZONTAL_SPACED, originalCompositeNames.ACTION_SET_VERTICAL)]
  },
  ComponentPanel: {
    displayName: compositeNames.COMPONENT_PANEL,
    className: 'composite-popup composite-popup-small-size responsive-component-panel',
    childrenTypes: [childType.once(controlNames.PANEL_HEADER), childType.once(originalCompositeNames.PANEL_CONTENT), childType.optional(originalCompositeNames.ACTION_SET_HORIZONTAL, originalCompositeNames.ACTION_SET_HORIZONTAL_SPACED, originalCompositeNames.ACTION_SET_VERTICAL)]
  },
  InputWithMentions: {
    displayName: compositeNames.INPUT_WITH_MENTIONS,
    className: 'composite-input-with-mentions',
    childrenTypes: [childType.once(controlNames.INPUT_WITH_MENTIONS), childType.optional(controlNames.BUTTON), childType.optional(controlNames.BUTTON)]
  },
  ButtonTextLabelAndIconButtonInRow: {
    displayName: compositeNames.BUTTON_TEXT_LABEL_AND_ICON_BUTTON_IN_ROW,
    className: 'composite-button-text-label-and-icon-button-in-row',
    childrenTypes: [childType.once(controlNames.BUTTON), childType.once(compositeNames.TEXT_LABEL_WITH_ICON)]
  }
};